module.exports = __webpack_public_path__ + "img/cart.a922648a.svg";